import { createSelector } from 'reselect';
import { utils } from '@saucelabs/sl-module-performance';

const performanceContainer = (store) => store.apps.extendedDebugging;

const containerSelector = createSelector(
  performanceContainer,
  (store) => store.user,
  (store) => store.apps.performance,
  (performanceState, user, performance) => ({
    loading: performanceState.container.get('loading'),
    job: performanceState.container.get('job'),
    build: performanceState.container.get('build'),
    user,
    regressionURLList: utils.prepareRegressionList(performance.regression.get('performanceRegressions')),
    showAcknowledgeBanner: performance.regression.get('showAcknowledgeBanner'),
  }),
);

export {
  containerSelector,
  performanceContainer,
};
